import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import FacebookProvider, {Like} from 'react-facebook';

import {FaceBookLikeButtonWrppaer, LinkStyled, FacebookLikeStyled} from './FacebookLike.style';

const FacebookLike = ({ url, pageContext }) => (
  <FacebookLikeStyled pageContext={pageContext}>
    <FaceBookLikeButtonWrppaer>
      <FacebookProvider appId="-1">
        <Like
          href={url}
          colorScheme="dark"
          layout="button"
          size="large"
          showFaces
        />
      </FacebookProvider>
    </FaceBookLikeButtonWrppaer>
    <FormattedMessage
      id="thirdParty.facebook.getDeals"
      values={{
        link: (
          <LinkStyled
            to={url}
            target="_blank"
            data-rw="navigation--fb-page-link"
          >
            <FormattedMessage id="thirdParty.facebook.like" />
          </LinkStyled>
        )
      }}
    />
  </FacebookLikeStyled>
);

FacebookLike.propTypes = {
  url: PropTypes.string.isRequired,
  pageContext: PropTypes.string
};

export default FacebookLike;



// WEBPACK FOOTER //
// ./components/FacebookLike/FacebookLike.js